module.exports = __webpack_public_path__ + "static/media/IMG_5971.a573044b.JPG";